/* eslint-disable import/prefer-default-export */

export const percentage = (numerator, denomonator) => {
  const val = (numerator / denomonator) * 100;
  return `${val}%`;
};
